<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            入账记录
        </div>
        <div style="padding: 20px;">
            <div>
                <el-row>
                    <Search :searchForm='searchForm' :searchData='searchData' v-on:getList='getList' ref="search">
                        <!-- <template slot="button">
                            <el-button type="primary" @click="noAccountingRecord">待入账</el-button>
                        </template> -->
                        <template slot="daterange">
                            <Daterange :startTime="searchForm.startTime" :endTime="searchForm.endTime" @dataChange='dataChange'></Daterange>
                        </template>
                    </Search>
                </el-row>
                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>
                    <el-table v-loading="tableLoading" :data="tableData" :height="th" border style="width: 100%;">
                        <el-table-column prop="businessDTO.businessName" label="商家名称"></el-table-column>
                        <el-table-column prop="createTime" :formatter="timefilter" label="时间"></el-table-column>
                        <el-table-column prop="price" label="入账金额（元）"></el-table-column>
                        <el-table-column prop="status" label="状态">
                            <template slot-scope="scope">
                                <el-tag type="danger" size="medium" v-if="scope.row.status==1">未入账</el-tag>
                                <el-tag type="success" size="medium" v-if="scope.row.status==2">已入账</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="200">
                            <template slot-scope="scope">
                                <el-button type="primary" size="mini" @click="handleInfo(scope.row)">详情</el-button>
                                <el-button type="danger" size="mini" :disabled="scope.row.status==2" @click="handleEdit(scope.row)">转账</el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    :current-page.sync="currentPage"  @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>
                </template>
            </div>
        </div>
        <el-dialog title="商家转账" :visible.sync="dialogFormVisible" width="450px" custom-class='checkinTime'>
            <el-alert title="此转账金额需与入账金额一致" type="warning"> </el-alert>
            <div class="bankInfo">
                <div>银行名称：{{businessBank.bankName}}</div>
                <div>银行支行：{{businessBank.bankBranch}}</div>
                <div>银行卡号：{{businessBank.bankNumber}}</div>
            </div>
            <div class="bankPrice">
                <span>转账金额</span>
                <el-input-number v-model="price" :min='0' :precision="2" placeholder="请输入优惠金额" :controls='false' class="inputMoneyNumber" style="width:100%;"></el-input-number>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="accountsSubmit">确 定</el-button>
            </div>
        </el-dialog>
        <Info ref="myInfo" v-show="showModalInfo"  v-on:closeInfo="showModalInfo=false" v-on:getList="getList"></Info>
    </div>
</template>


<script>

    import {timeStr,timefilters,getMonthDay} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import Info from "./Info";
    import {getStaffCode} from "@/utils/auth";
    import Search from "@/components/Search";
    import Daterange from "@/components/Daterange";
    export default {
        name: "Role",
        data(){
            return{
                tableLoading:false,
                showModalInfo:false,
                showModalStayInfo:false,
                dialogFormVisible:false,
                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                type:'',
                statusValue:[[-1,'全部状态'],[1,'未入账'],[2,'已入账']],
                businessValue:[],
                businessCode:'',
                businessBank:'',
                price:'',
                accountingRecordData:'',
                searchForm:{
                    businessCode:'',
                    startTime:'',
                    endTime:'',
                    status:1,
                }
            }
        },
        components:{
            Info,Daterange,Search
        },
        created(){
            this.init();
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{
            init(){
                this.searchData=[
                    {span:12,name:'商家',value:'businessCode',type:'select',clearable:true,options:this.businessValue,props:{label:'businessName',value:'businessCode'}},
                    {span:12,name:'状态',value:'status',type:'select',options:this.statusValue,props:{label:'1',value:'0'}},
                    {span:24,name:'起止时间',width:495,value:'daterange',type:'slot'},
                ]
                this.searchForm.endTime = getMonthDay('e', 0)
                this.searchForm.startTime = getMonthDay('s', 0)
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Business/ListSuper",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode:getStaffCode(),
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.businessValue = response.data.data;
                        this.searchData[0].options=this.businessValue
                        this.$refs.search.getWidth();
                    }else if(response.data.error == 1){
                        this.$message.error(response.data.message)
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            timefilter(row,index,column){
                return timefilters(column).slice(0,10)
            },
            handleInfo(row){
                this.showModalInfo=true
                this.$refs.myInfo.init(row);
            },
            noAccountingRecord(){
                this.showModalStayInfo=true
                this.$refs.myStayInfo.init();
            },
            handleEdit(row){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"BusinessBank/getByBusiness",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        businessCode:row.businessCode
                    }
                }).then( (response)=> {
                    this.tableLoading=false
                    if(response.data.error == 0){
                        var data=response.data.data
                        if(!data){
                            this.$message.error('此商家未绑定银行卡!')
                        }else if(data.status==2){
                            this.$message.error('此商家银行卡已禁用!')
                        }else{
                            this.accountingRecordData=row
                            this.businessBank=data
                            this.dialogFormVisible=true
                        }
                    }else if(response.data.error == 1){
                        this.$message.error(response.data.message)
                    }
                }).catch(function (error) {
                    console.log(error);
                });
                

            },
            accountsSubmit(){
                if(this.price!=this.accountingRecordData.price){
                    this.$message.error("转账金额输入有误")
                    return;
                }
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"AccountingRecord/TransferAccounts",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        accountingRecordCode:this.accountingRecordData.accountingRecordCode
                    }
                }).then( (response)=> {
                    this.tableLoading=false
                    if(response.data.error == 0){
                        this.$message.success('操作成功！')
                        this.dialogFormVisible=false
                        this.getList();
                    }else if(response.data.error == 1){
                        this.$message.error(response.data.message)
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            dataChange(val){
                this.searchForm.startTime=val[0]
                this.searchForm.endTime=val[1]
            },
            getList(isSearch) {
                if(isSearch)this.currentPage=1
                var _this=this
                this.tableLoading=true
                let data={
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                    staffCode: getStaffCode(),
                    pageIndex:this.currentPage,
                    pageSize:this.pageSize,
                }
                Object.assign(data,this.searchForm)
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"AccountingRecord/PageAll",
                    data: data
                }).then( (response)=> {
                    this.tableLoading=false
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                        this.$message.error(response.data.message)
                    }
                }).catch(function (error) {
                    _this.tableLoading=false
                    console.log(error);
                });
            },
            statusTitle(row){
                if(row.status == 1){
                    return "正常";
                }
                if(row.status == 2){
                    return "废弃";
                }
                return "其它";
            },
        }
    }
</script>

<style lang="scss" scoped>
    .bankInfo{
        line-height: 30px;
        font-size: 16px;
        margin-top: 10px;
        color: #333;
    }
    .inputMoneyNumber /deep/ .el-input__inner{
        text-align: left;
    }
    .bankPrice{
        margin-top: 10px;
        span{
            line-height: 30px;
            margin-left: 5px;
        }
    }
</style>
